export const EXSBDOCUMENTTYPE_DELETE_RESET = 'EXSBDOCUMENTTYPE_DELETE_RESET'
export const EXSBDOCUMENTTYPE_DELETE_SET_ERROR = 'EXSBDOCUMENTTYPE_DELETE_SET_ERROR'
export const EXSBDOCUMENTTYPE_DELETE_SET_DELETED = 'EXSBDOCUMENTTYPE_DELETE_SET_DELETED'
export const EXSBDOCUMENTTYPE_DELETE_TOGGLE_LOADING = 'EXSBDOCUMENTTYPE_DELETE_TOGGLE_LOADING'
